// Variant Swatches JavaScript
(function() {
  // Prevent multiple initializations
  if (window.variantSwatchesInitialized) {
    return;
  }
  window.variantSwatchesInitialized = true;

  console.log('Variant Swatches: Initializing...');

  class VariantSwatches {
    constructor() {
      this.init();
    }

    init() {
      // Use event delegation on document to handle dynamically loaded swatches
      document.addEventListener('click', (e) => {
        const button = e.target.closest('.variant-swatch');
        if (button) {
          console.log('Variant Swatches: Button clicked', button);
          e.preventDefault();
          e.stopPropagation();
          this.handleSwatchClick(button);
        }
      });
      console.log('Variant Swatches: Event listener attached');
    }

    handleSwatchClick(clickedButton) {
      const productId = clickedButton.getAttribute('data-product-id');
      const variantId = clickedButton.getAttribute('data-variant-id');
      const imageUrl = clickedButton.getAttribute('data-image');
      const variantName = clickedButton.getAttribute('data-variant-name');

      console.log('Variant Swatches: Handling click', {
        productId,
        variantId,
        imageUrl,
        variantName
      });

      // Remove active class from all swatches for this product
      const productSwatches = document.querySelectorAll(
        `.variant-swatch[data-product-id="${productId}"]`
      );
      productSwatches.forEach(swatch => {
        swatch.classList.remove('active');
      });

      // Add active class to clicked swatch
      clickedButton.classList.add('active');

      // Update the product image
      this.updateProductImage(productId, imageUrl);

      // Update the variant name in the heading
      this.updateVariantName(productId, variantName);

      // Update product links with variant parameter
      this.updateProductLinks(productId, variantId);
    }

    updateProductImage(productId, imageUrl) {
      // Find the product image by product ID
      const productImage = document.getElementById(productId);
      
      console.log('Variant Swatches: Updating image', { productId, imageUrl, found: !!productImage });
      
      if (productImage && imageUrl) {
        // Add a fade effect
        productImage.style.opacity = '0.5';
        
        // Update the image source
        productImage.src = imageUrl;
        
        // Wait for image to load, then fade back in
        productImage.onload = () => {
          productImage.style.opacity = '1';
          console.log('Variant Swatches: Image loaded');
        };
      }
    }

    updateVariantName(productId, variantName) {
      // Find the variant name heading by product ID
      const variantHeading = document.getElementById(`variant-name-${productId}`);
      
      console.log('Variant Swatches: Updating variant name', { productId, variantName, found: !!variantHeading });
      
      if (variantHeading && variantName) {
        // Update the heading text with uppercase variant name
        variantHeading.textContent = variantName.toUpperCase();
      }
    }

    updateProductLinks(productId, variantId) {
      // Find the product card wrapper
      const productCard = document.querySelector(`[data-product-id="${productId}"]`)?.closest('.card-wrapper');
      
      console.log('Variant Swatches: Updating links', { productId, variantId, found: !!productCard });
      
      if (productCard) {
        // Find all product links within this card
        const productLinks = productCard.querySelectorAll('a.full-unstyled-link');
        
        productLinks.forEach(link => {
          const currentHref = link.getAttribute('href');
          if (currentHref && currentHref !== '#') {
            // Parse the URL and update the variant parameter
            const url = new URL(currentHref, window.location.origin);
            url.searchParams.set('variant', variantId);
            link.setAttribute('href', url.pathname + url.search);
          }
        });
      }
    }
  }

  // Initialize the variant swatches when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      new VariantSwatches();
      initMainProductSync();
    });
  } else {
    new VariantSwatches();
    initMainProductSync();
  }

  // Synchronize main product color selection with product recommendations
  function initMainProductSync() {
    console.log('Variant Swatches: Initializing main product sync');
    
    // Store the currently selected color
    let currentSelectedColor = null;
    
    // Listen for changes on variant radio buttons or selects in the main product
    document.addEventListener('change', (e) => {
      // Check if this is a variant input (radio button or select)
      const input = e.target;
      
      // Check for radio buttons in variant-radios
      if (input.type === 'radio' && input.name && input.closest('variant-radios')) {
        const fieldset = input.closest('fieldset');
        const legend = fieldset?.querySelector('.form__label');
        const optionName = legend?.textContent?.trim();
        
        // Check if this is a color option (case-insensitive)
        if (optionName && (optionName.toLowerCase() === 'color' || 
                          optionName.toLowerCase() === 'colore' || 
                          optionName.toLowerCase() === 'colour')) {
          const colorValue = input.value;
          console.log('Variant Swatches: Main product color variant selected:', colorValue);
          currentSelectedColor = colorValue;
          
          // Delay sync slightly to allow the main product to update first
          setTimeout(() => {
            syncRecommendationsWithMainProduct(colorValue);
          }, 150);
        }
      }
      
      // Check for select dropdowns in variant-selects
      if (input.tagName === 'SELECT' && input.closest('variant-selects')) {
        const label = input.previousElementSibling;
        const optionName = label?.textContent?.trim();
        
        // Check if this is a color option (case-insensitive)
        if (optionName && (optionName.toLowerCase() === 'color' || 
                          optionName.toLowerCase() === 'colore' || 
                          optionName.toLowerCase() === 'colour')) {
          const colorValue = input.value;
          console.log('Variant Swatches: Main product color variant selected:', colorValue);
          currentSelectedColor = colorValue;
          
          // Delay sync slightly to allow the main product to update first
          setTimeout(() => {
            syncRecommendationsWithMainProduct(colorValue);
          }, 150);
        }
      }
    });
    
    // Also listen for clicks on main product thumbnails as a fallback
    document.addEventListener('click', (e) => {
      const thumbnail = e.target.closest('.thumbnail-list__item');
      if (thumbnail) {
        const colorName = thumbnail.getAttribute('data-thumbnail-color');
        if (colorName) {
          console.log('Variant Swatches: Main product thumbnail clicked:', colorName);
          currentSelectedColor = colorName;
          
          // Delay sync slightly to allow the main product to update first
          setTimeout(() => {
            syncRecommendationsWithMainProduct(colorName);
          }, 150);
        }
      }
    }, true); // Use capture phase

    // Watch for when product recommendations are loaded dynamically
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            // Check if the added node contains variant swatches
            if (node.nodeType === 1) { // Element node
              const hasSwatches = node.querySelector && node.querySelector('.variant-swatch');
              if (hasSwatches && currentSelectedColor) {
                console.log('Variant Swatches: Recommendations loaded, syncing with color:', currentSelectedColor);
                // Small delay to ensure DOM is fully ready
                setTimeout(() => {
                  syncRecommendationsWithMainProduct(currentSelectedColor);
                }, 100);
              }
            }
          });
        }
      });
    });

    // Observe the product-recommendations element for changes
    const recommendationSection = document.querySelector('product-recommendations');
    if (recommendationSection) {
      observer.observe(recommendationSection, {
        childList: true,
        subtree: true
      });
      console.log('Variant Swatches: Watching for recommendations to load');
    }

    // Also check if there's already a selected color on page load
    setTimeout(() => {
      const activeMainThumbnail = document.querySelector('.thumbnail-list__item button[aria-current="true"]');
      if (activeMainThumbnail) {
        const thumbnail = activeMainThumbnail.closest('.thumbnail-list__item');
        const colorName = thumbnail?.getAttribute('data-thumbnail-color');
        if (colorName) {
          console.log('Variant Swatches: Initial color detected:', colorName);
          currentSelectedColor = colorName;
          syncRecommendationsWithMainProduct(colorName);
        }
      }
    }, 500);
  }

  function syncRecommendationsWithMainProduct(selectedColor) {
    // Find all product recommendation cards
    const recommendationSection = document.querySelector('product-recommendations');
    if (!recommendationSection) {
      console.log('Variant Swatches: No recommendations section found');
      return;
    }

    // Find all variant swatches in recommendations
    const allSwatches = recommendationSection.querySelectorAll('.variant-swatch');
    
    console.log('Variant Swatches: Found', allSwatches.length, 'swatches in recommendations');

    if (allSwatches.length === 0) {
      console.log('Variant Swatches: No swatches found yet, recommendations may still be loading');
      return;
    }

    // Group swatches by product
    const productSwatchGroups = {};
    allSwatches.forEach(swatch => {
      const productId = swatch.getAttribute('data-product-id');
      if (!productSwatchGroups[productId]) {
        productSwatchGroups[productId] = [];
      }
      productSwatchGroups[productId].push(swatch);
    });

    // For each product, try to find and activate the matching color variant
    Object.keys(productSwatchGroups).forEach(productId => {
      const swatches = productSwatchGroups[productId];
      
      // Try to find a swatch that matches the selected color
      const matchingSwatch = swatches.find(swatch => {
        const variantName = swatch.getAttribute('data-variant-name');
        // Case-insensitive comparison
        return variantName && variantName.toLowerCase() === selectedColor.toLowerCase();
      });

      if (matchingSwatch && !matchingSwatch.classList.contains('active')) {
        console.log('Variant Swatches: Found matching color for product', productId, ':', selectedColor);
        
        // Simulate a click on the matching swatch
        matchingSwatch.click();
      } else if (!matchingSwatch) {
        console.log('Variant Swatches: No matching color found for product', productId);
      }
    });
  }
})();
